// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"9b484a60","453":"8e965e8d"}[chunkId] + ".chunk.js";
};